<template>
  <el-select v-model="periodSelected"
                 class="select-transparent-noborder period mr-3"
                 @change="changePeriod()">
    <el-option v-for="option in periods"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"/>
  </el-select>
</template>

<script>
import NProgress from 'nprogress'
export default {
  name: 'Period-Selector',
  created () {
    this.periodSelected = 'this month+'
  },
  computed: {
    periods() { return this.$store.getters.periods },
    periodSelected: {
      get () { return this.$store.getters.periodSelected ? this.$store.getters.periodSelected.value : 'this month+'},
      set (period) { this.$store.commit('SET_PERIOD_SELECTED', this.$store.getters.periods.find(p => p.value == period)) }
    }
  },
  methods: {
    
    async changePeriod () {
      console.log('>>>> changePeriod():')
      //this.$store.commit('SET_PERIOD_SELECTED', this.$store.getters.periods.find(p => p.value ==this.periodSelected))
      // fetch the corresponding data
      // console.log('this.periodSelected = ', this.periodSelected)
      const res = await this.$store.dispatch('fetchDataset', { period: this.periodSelected })
      if (res && res.errors && res.status == 401) {
        this.$store.dispatch('logout')
      }
    }
  }
}
</script>

<style>

.select-transparent-noborder.period {
  width: 145px;
}
</style>